// ============================================================================
// CENTROID DECOMPOSITION - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'centroid-decomposition',
  name: 'Centroid Decomposition',
  category: 'Graphs',
  complexity: {
    time: 'O(V log V)',
    space: 'O(V)'
  },
  description: 'A divide-and-conquer technique for trees that recursively decomposes the tree by removing centroids. It enables efficient solutions to problems like counting paths, distance queries, and subtree queries.'
};
